import { RangeSearchParams, SearchParams, SearchType, ValuesSearchParams } from '../../types';

import { sanitizeInput } from './searchValidations';

/**
 * This function is used to append a value to the current query.
 * It will replace the last, partially typed value and replaces it with the newly added value.
 *
 * Note: this will not validate for the json exception.
 *
 * @param currentQuery
 * @param query
 * @returns
 */
export const formatQuery = (currentQuery: string, query: string, searchType: SearchType = 'empty'): string => {
  const { seperator, searchValues } = sanitizeInput(currentQuery, searchType);
  // Replace the last value with the new value
  searchValues[searchValues.length - 1] = `${query}`;

  // Join the values back into a string
  return searchValues.join(seperator);
};

/** Get the searchValue of a history item */
export const getSearchValue = (searchParams: SearchParams) => {
  const asRange = searchParams as RangeSearchParams;
  const asValues = searchParams as ValuesSearchParams;
  if (asRange?.fromValue && asRange?.toValue) return `${asRange.fromValue} - ${asRange.toValue}`;
  return Array.isArray(asValues.searchValue) ? asValues.searchValue.join(', ') : asValues.searchValue;
};
